import api from './api';

const ENDPOINT = 'point-transactions/';

export default {
  get: (params = null) => api.get(`${ENDPOINT}get-by-client`, { params }),
  getTypes: () => api.get(`${ENDPOINT}types`),
};
